import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getMPUrl = (params, urlParams) => {
  return axios.request({
    url: '/wechat/mediaplatform/getmpurl' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const hasUserSubscribe = (params, urlParams) => {
  return axios.request({
    url: '/wechat/mediaplatform/hasusersubscribe/' + params.openId + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getSignature = (params, urlParams) => {
  return axios.request({
    url: '/wechat/mediaplatform/getsignature' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

